import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React, { FC } from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Tooltip from 'core/elements/tooltip'
import colors from 'core/themes/base/colors'
import Theme from 'core/themes/model'
import SimpleLink from './SimpleLink'

interface Props {
  title: string | (() => React.ReactNode)
  icon?: string
  color?: string
  link?: string
}

const colorMap = {
  white: '100',
  black: '700',
}

type IIconColor = Props['color']

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  icon: {
    cursor: 'default',
    fontWeight: 300,
    color: colors.grey[300],
    '&:hover': {
      color: theme.palette.grey[700],
    },
  },
  iconLink: {
    cursor: 'pointer',
  },
  iconWhite: {
    color: theme.palette.grey[100],
  },
  iconBlack: {
    color: theme.palette.grey[700],
  },
}))

const HelpContainer: FC<Props> = ({
  title,
  icon = 'info-circle',
  color = '',
  link = undefined,
}) => {
  if (!title) {
    return null
  }

  const classes = useStyles()

  const iconClassName = clsx(classes.icon, {
    [classes.iconLink]: !!link,
    [classes.iconWhite]: color === 'white',
    [classes.iconBlack]: color === 'black',
  })

  const content = link ? (
    <SimpleLink src={link}>
      <FontAwesomeIcon className={iconClassName}>{icon}</FontAwesomeIcon>
    </SimpleLink>
  ) : (
    <FontAwesomeIcon className={iconClassName}>{icon}</FontAwesomeIcon>
  )

  if (typeof title === 'function') {
    const tooltipContent = title()
    return <Tooltip customBody={tooltipContent}>{content}</Tooltip>
  }

  return <Tooltip message={title}>{content}</Tooltip>
}

export default HelpContainer
